<template>
  <div class="tipo">
    <div class="centro">
      <h1><span>Consulta por Ordem Cronológica</span></h1>
      <BuscaSimplesCards titulo="Consultas Rápidas" :cards="cardsLegislacao" />
      <Loading v-if="carregando" />
      <ErroResultados v-if="!carregando && erro" />
      <PainelAnos
        v-if="!carregando && !erro"
        :anos="anos"
        :generateUrl="generateUrl"
      />
    </div>
  </div>
</template>

<script>
import LegislacaoMunicipalApi from "../../../services/LegislacaoMunicipalApi";
import Loading from "../../../components/Loading";
import ErroResultados from "../../../components/ErroResultados";
import PainelAnos from "../../../components/PainelAnos";
import BuscaSimplesCards from "../../../components/BuscaSimplesCards.vue"; // Import BuscaSimplesCards
import { mixinLegislacao } from "../../../mixins/mixinLegislacao";

import metaDados from "../../../helpers/metaDados";

export default {
  name: "PorAnoMunicipal",
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  metaInfo() {
    return {
      title: "Pesquisa de Legislação Municipal por Ano",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content:
            "Pesquisa a Legislação Municipal por Ano - Casa Civil do Estado de Goiás",
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content:
            "Pesquisa a Legislação Municipal por Ano - Casa Civil do Estado de Goiás",
        },
        ...metaDados(this.$route),
      ],
    };
  },
  mixins: [mixinLegislacao],
  data() {
    return {
      carregando: true,
      erro: false,
      anos: [],
      enteFederativoId: null, // New property to store enteFederativoId
      cardsLegislacao: [ // Override cardsLegislacao
        {
          rota: { name: "LegislacaoPorEnteFederativoPorTipo", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-tipo-legislacao2.png"),
          iconeClasse: "legisla-icon",
          titulo: "Tipo de Legislação",
          descricao: "Consulte a Legislação<br /> por <strong>tipo</strong>",
        },
        {
          rota: { name: "LegislacaoPorEnteFederativoPorCategoria", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-categoria2.png"),
          iconeClasse: "categoria-icon",
          titulo: "Categoria",
          descricao: "Consulte a Legislação<br /> por <strong>categoria</strong>",
        },
        {
          rota: { name: "LegislacaoPorEnteFederativoPorAutor", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-autor2.png"),
          iconeClasse: "autor-icon",
          titulo: "Autor",
          descricao: "Consulte a Legislação<br /> por <strong>autor</strong>",
        },
        {
          rota: { name: "LegislacaoPorEnteFederativoPorAno", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-indice-cronologico2.png"),
          iconeClasse: "indice-icon",
          titulo: "Índice Cronológico",
          descricao: "Consulte a Legislação<br /> por <strong>ano</strong>",
        },
      ],
    };
  },
  components: {
    Loading,
    ErroResultados,
    PainelAnos,
    BuscaSimplesCards, // Register BuscaSimplesCards
  },
  created() {
    this.legislacaoApi = new LegislacaoMunicipalApi();

    this.findEnteFederativoAndLoadAnos(); // New method to find ente and load anos
  },
  methods: {
    findEnteFederativoAndLoadAnos: async function () {
      try {
        const allEntesFederativos = await this.legislacaoApi.getEntesFederativos();
        const enteFederativo = allEntesFederativos.find(ente => ente.slug === this.slug);

        if (!enteFederativo) {
          this.erro = true;
          this.carregando = false;
          return;
        }
        this.enteFederativoId = enteFederativo.id;
        this.carregarAnos();
      } catch (err) {
        console.log("findEnteFederativoAndLoadAnos", err);
        this.erro = true;
        this.carregando = false;
      }
    },
    carregarAnos: async function () {
      try {
        if (this.legislacaoApi.cancelTokens.getAnosByEnteFederativo) {
          this.legislacaoApi.cancelTokens.getAnosByEnteFederativo.cancel();
        }

        this.carregando = true;
        this.erro = false;
        this.anos = await this.legislacaoApi.getAnosByEnteFederativo(this.enteFederativoId); // Use enteFederativoId
        this.carregando = false;
      } catch (err) {
        if (this.legislacaoApi.isCancel(err)) {
          return;
        }
        console.log(err);
        this.erro = true;
        this.carregando = false;
      }
    },
    generateUrl: function (ano) {
      return { name: "LegislacaoPorEnteFederativoBySlug", params: { slug: this.slug }, query: { ano, busca_avancada: 1 } }; // Use slug and new route name
    },
  },
};
</script>

<style lang="scss" scoped>
h1 span{
   background-color: #ffb24e;
  width: fit-content;
  border-radius: 12px;
  color: #0e489f;
  font-size: 1.5rem;
  padding: 0 0.3rem;
  margin: 2rem 0rem 1.5rem 0.5rem;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;/* limita o fundo ao tamanho do texto */
}
.tipo {
  min-height: calc(100vh - 10rem);
  margin-bottom: 5rem;
}
</style>
